import { Product } from '@/api/types/product';
import { ProductModel } from '@/models/product';

export const currencySignMappings = [
    {
        sign: 'Є',
        currency: 'EUR',
    },
    {
        sign: '$',
        currency: 'USD',
    },
    {
        sign: '£',
        currency: 'GBP',
    }
];

function transformCurrencySign(currency: string): string {
    const mapping = currencySignMappings.find(mapping => mapping.currency === currency)

    return mapping ? mapping.sign : currency;
}

export function transformProduct(product: Product): ProductModel {
    return {
        ...product,
        currencySign: transformCurrencySign(product.currency)
    };
}

export function transformProducts(products: Product[]): ProductModel[] {
    return products.map(transformProduct);
}
